import React, {useEffect } from 'react';
import { Container, Row, Col,Tab,Nav } from 'react-bootstrap';
import { motion, useAnimation,AnimatePresence  } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';
import CountUp from 'react-countup';
// import { SocialIcon } from 'react-social-icons';
const AboutPage = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });
  
  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);
  const statistics = [
    { number: 150000, label: 'Annual Visitors', prefix: '+' },
    { number: 25, label: 'Tourist Sites', prefix: '' },
    { number: 95, label: 'Satisfaction Rate', prefix: '', suffix: '%' },
    { number: 1200, label: 'Local Guides', prefix: '+' }
  ];
// Simple SocialIcon component
const SocialIcon = ({ platform }) => {
  const icons = {
    linkedin: "🔗",
    twitter: "🐦",
    facebook: "📘"
  };
  return <span>{icons[platform.toLowerCase()] || '🌐'}</span>;
};
  const teamMembers = [
    {
      name: 'Ahmed Mohammed',
      position: 'Bureau Director',
      image: '👤',
      bio: 'Experienced tourism professional with 15+ years in the industry.',
      expertise: ['Tourism Management', 'Strategic Planning'],
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Sara Ibrahim',
      position: 'Tourism Development Head',
      image: '👤',
      bio: 'Specialist in sustainable tourism development.',
      expertise: ['Sustainable Tourism', 'Project Management'],
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Abdi Hassan',
      position: 'Cultural Heritage Manager',
      image: '👤',
      bio: 'Expert in cultural preservation and heritage management.',
      expertise: ['Cultural Heritage', 'Community Relations'],
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Fatima Yusuf',
      position: 'Community Relations',
      image: '👤',
      bio: 'Specializes in community engagement and local partnerships.',
      expertise: ['Community Engagement', 'Public Relations'],
      social: { linkedin: '#', twitter: '#' }
    }
  ];

  const timelineData = [
    {
      year: '2008',
      title: 'Establishment',
      description: 'Foundation of Afar Tourism Bureau with the vision of promoting regional tourism.'
    },
    {
      year: '2012',
      title: 'Infrastructure Development',
      description: 'Major investments in tourist facilities and infrastructure across key sites.'
    },
    {
      year: '2015',
      title: 'International Recognition',
      description: 'Received UNESCO recognition for preservation efforts of natural sites.'
    },
    {
      year: '2023',
      title: 'Digital Transformation',
      description: 'Launched comprehensive digital platforms for enhanced tourist experience.'
    }
  ];
  const socialLinks = [
    { url: 'https://facebook.com', platform: 'Facebook' },
    { url: 'https://twitter.com', platform: 'Twitter' },
    // Add other links as needed
  ];

  const keyFeatures = [
    {
      icon: '🌋',
      title: 'Volcanic Wonders',
      description: 'Home to active volcanoes including Erta Ale and Dallol'
    },
    {
      icon: '🏺',
      title: 'Cultural Heritage',
      description: 'Rich traditions and customs of the Afar people'
    },
    {
      icon: '🌍',
      title: 'Geological Marvels',
      description: 'Unique formations and mineral structures'
    },
    {
      icon: '🏃',
      title: 'Adventure Tourism',
      description: 'Exciting trekking and expedition opportunities'
    }
  ];

  return (
    <StyledAboutPage ref={ref}>
    <ParallaxHero>
      <motion.div
        className="hero-content"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h1>Discover the Danakil Depression</h1>
        <p>Journey through Earth's Most Extreme Landscape</p>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="cta-button"
        >
          Explore Now
        </motion.button>
      </motion.div>
    </ParallaxHero>

    <Container>
      <Section>
        <TabSection>
          <Tab.Container id="mission-tabs" defaultActiveKey="mission">
            <Nav variant="pills" className="tab-nav">
              <Nav.Item>
                <Nav.Link eventKey="mission">Mission</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="vision">Vision</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="values">Values</Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <AnimatePresence mode='wait'>
                <Tab.Pane eventKey="mission">
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.5 }}
                  >
                    <h3>Our Mission</h3>
                    <p>To promote sustainable tourism while preserving the unique natural and cultural heritage of the Afar region.</p>
                  </motion.div>
                </Tab.Pane>
                <Tab.Pane eventKey="vision">
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.5 }}
                  >
                    <h3>Our Vision</h3>
                    <p>To become a leading destination for sustainable adventure tourism, showcasing the unique geological wonders of the Danakil Depression.</p>
                  </motion.div>
                </Tab.Pane>
                <Tab.Pane eventKey="values">
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.5 }}
                  >
                    <h3>Our Values</h3>
                    <ul>
                      <li>Sustainability and Environmental Protection</li>
                      <li>Cultural Preservation and Respect</li>
                      <li>Community Empowerment</li>
                      <li>Adventure and Discovery</li>
                    </ul>
                  </motion.div>
                </Tab.Pane>
              </AnimatePresence>
            </Tab.Content>
          </Tab.Container>
        </TabSection>
      </Section>

      <Section>
      <StatsSection>
            <Row>
              {statistics && statistics.map((stat, index) => (
                <Col key={index} md={3} sm={6}>
                  <motion.div
                    className="stat-card"
                    initial={{ opacity: 0, y: 20 }}
                    animate={controls}
                    variants={{
                      visible: { opacity: 1, y: 0 }
                    }}
                    transition={{ delay: index * 0.2 }}
                  >
                    <h3>
                      {stat.prefix}
                      <CountUp
                        end={stat.number}
                        duration={2.5}
                        separator=","
                        start={0}
                        triggerOnce
                      />
                      {stat.suffix}
                    </h3>
                    <p>{stat.label}</p>
                  </motion.div>
                </Col>
              ))}
            </Row>
      </StatsSection>
      </Section>

      <Section>
    <motion.h2
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="section-title"
    >
      Our Journey Through Time
    </motion.h2>
    <EnhancedTimeline>
      {timelineData.map((item, index) => (
        <motion.div
          key={index}
          className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
          initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{
            type: "spring",
            stiffness: 100,
            damping: 12,
            delay: index * 0.2
          }}
        >
          <div className="timeline-content">
            <motion.div
              className="timeline-marker"
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 200, delay: index * 0.2 }}
            >
              <span className="year">{item.year}</span>
            </motion.div>
            <motion.div
              className="content-wrapper"
              whileHover={{
                scale: 1.02,
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
              }}
            >
              <div className="icon-wrapper">
                {item.icon || "🌟"}
              </div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <motion.div 
                className="milestone-badge"
                whileHover={{ rotate: 360 }}
                transition={{ duration: 0.5 }}
              >
                Milestone {index + 1}
              </motion.div>
            </motion.div>
          </div>
        </motion.div>
      ))}
    </EnhancedTimeline>
      </Section>

      <Section>
        <motion.h2
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="section-title"
    >
      Meet Our Expert Team
    </motion.h2>
    <EnhancedTeamGrid>
    {teamMembers && teamMembers.map((member, index) => (
              <motion.div
                key={index}
                className="team-card"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  delay: index * 0.1
                }}
              >
          <motion.div 
            className="card-inner"
            whileHover={{ 
              y: -15,
              transition: { type: "spring", stiffness: 300 }
            }}
          >
            <motion.div 
              className="member-image-wrapper"
              whileHover={{ scale: 1.1 }}
            >
              <div className="member-image">
                {member.image}
                <div className="image-overlay" />
              </div>
            </motion.div>
            <div className="member-info">
              <h3>{member.name}</h3>
              <span className="position">{member.position}</span>
              <p className="bio">{member.bio}</p>
              <motion.div 
                className="social-links"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
              >
                {Object.entries(member.social).map(([platform, link], idx) => (
                  <motion.a
                    key={platform}
                    href={link}
                    whileHover={{ 
                      scale: 1.2,
                      y: -5,
                      transition: { type: "spring", stiffness: 300 }
                    }}
                    className={`social-icon ${platform}`}
                  >
                    <SocialIcon platform={platform} />
                  </motion.a>
                ))}
              </motion.div>
            </div>
            <motion.div 
              className="expertise-tags"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              {member.expertise.map((tag, idx) => (
                <span key={idx} className="tag">{tag}</span>
              ))}
            </motion.div>
          </motion.div>
        </motion.div>
       ))}
    </EnhancedTeamGrid>
      </Section>

      <Section>
        <h2>Key Features</h2>
        <Row>
          {keyFeatures.map((feature, index) => (
            <Col key={index} md={4} sm={6}>
              <motion.div
                className="feature-card"
                initial={{ opacity: 0, y: 20 }}
                animate={controls}
                variants={{
                  visible: { opacity: 1, y: 0 }
                }}
                transition={{ delay: index * 0.2 }}
                whileHover={{ y: -5 }}
              >
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Section>

      <Section>
       <CTAWrapper>
      <motion.div
        className="cta-content"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2>Ready to Begin Your Adventure?</h2>
        <p>Connect with us and start planning your unforgettable journey</p>
        
        <motion.div 
          className="contact-grid"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <div className="contact-item">
            <motion.div
              className="icon-wrapper"
              whileHover={{ scale: 1.1, rotate: 5 }}
            >
              📞
            </motion.div>
            <div className="contact-info">
              <h4>Call Us</h4>
              <motion.a 
                href="tel:+1234567890"
                whileHover={{ color: '#2d7ba8' }}
              >
                +1 (234) 567-890
              </motion.a>
            </div>
          </div>

          <div className="contact-item">
            <motion.div
              className="icon-wrapper"
              whileHover={{ scale: 1.1, rotate: 5 }}
            >
              ✉️
            </motion.div>
            <div className="contact-info">
              <h4>Email Us</h4>
              <motion.a 
                href="mailto:info@danakil.com"
                whileHover={{ color: '#2d7ba8' }}
              >
                info@danakil.com
              </motion.a>
            </div>
          </div>
        </motion.div>

          <motion.div 
            className="social-bar"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            {socialLinks && socialLinks.map((social, index) => (
              <motion.a
                key={index}
                href={social.url}
                className={`social-icon ${social.platform}`}
                whileHover={{ 
                  y: -5,
                  scale: 1.2,
                  transition: { type: "spring", stiffness: 300 }
                }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <SocialIcon platform={social.platform} />
              </motion.a>
            ))}
          </motion.div>

        <motion.div 
          className="cta-buttons"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <motion.button
            className="primary-btn"
            whileHover={{ 
              scale: 1.05,
              boxShadow: "0 10px 20px rgba(45, 123, 168, 0.2)"
            }}
            whileTap={{ scale: 0.95 }}
          >
            Book Now
          </motion.button>
          <motion.button
            className="secondary-btn"
            whileHover={{ 
              scale: 1.05,
              boxShadow: "0 10px 20px rgba(52, 73, 94, 0.2)"
            }}
            whileTap={{ scale: 0.95 }}
          >
            Download Brochure
          </motion.button>
        </motion.div>
      </motion.div>
    </CTAWrapper>
      </Section>
    </Container>
  </StyledAboutPage>
  );
};
const ParallaxHero = styled.div`
  min-height: 100vh;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
              linear-gradient(135deg, #2d7ba8 0%, #34495e 100%);
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  padding: 1rem;

  .hero-content {
    width: 100%;
    max-width: 1200px;
    padding: clamp(1rem, 5vw, 2rem);
    
    h1 {
      font-size: clamp(2rem, 6vw, 4.5rem);
      font-weight: 800;
      margin-bottom: clamp(1rem, 3vw, 1.5rem);
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }

    p {
      font-size: clamp(1rem, 3vw, 1.5rem);
      margin-bottom: clamp(1.5rem, 4vw, 2rem);
      opacity: 0.9;
      max-width: 800px;
      margin-left: auto;
      margin-right: auto;
    }

    .cta-button {
      padding: clamp(0.8rem, 2vw, 1rem) clamp(1.5rem, 4vw, 2.5rem);
      font-size: clamp(1rem, 2vw, 1.2rem);
      border: none;
      background: #2d7ba8;
      color: white;
      border-radius: 50px;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(45, 123, 168, 0.2);
      width: fit-content;
      margin: 0 auto;

      &:hover {
        background: #34495e;
        transform: translateY(-2px);
      }

      @media (max-width: 480px) {
        width: 100%;
      }
    }
  }

  @media (max-width: 768px) {
    background-attachment: scroll;
  }
`;

const EnhancedTeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(300px, 100%), 1fr));
  gap: clamp(1.5rem, 3vw, 2.5rem);
  padding: clamp(1rem, 3vw, 2rem);
  max-width: 1400px;
  margin: 0 auto;
  width: 95%;

  .team-card {
    perspective: 1000px;
    
    .card-inner {
      background: white;
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;

      @media (hover: hover) {
        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(45, 123, 168, 0.2);

          .member-image-wrapper .image-overlay {
            opacity: 0.7;
          }

          .member-info {
            transform: translateY(-5px);
          }

          .social-links {
            opacity: 1;
            transform: translateY(0);
          }
        }
      }
    }

    .member-image-wrapper {
      position: relative;
      height: clamp(200px, 30vw, 300px);
      overflow: hidden;

      .member-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
      }
    }

    .member-info {
      padding: clamp(1rem, 3vw, 1.5rem);
      text-align: center;

      h3 {
        font-size: clamp(1.2rem, 2.5vw, 1.5rem);
        margin-bottom: 0.5rem;
      }

      .position {
        font-size: clamp(0.9rem, 1.5vw, 1rem);
      }

      .bio {
        font-size: clamp(0.85rem, 1.5vw, 0.95rem);
        line-height: 1.6;
      }
    }

    .social-links {
      display: flex;
      justify-content: center;
      gap: clamp(0.5rem, 1.5vw, 1rem);
      padding: 1rem;

      .social-icon {
        width: clamp(35px, 5vw, 40px);
        height: clamp(35px, 5vw, 40px);
      }
    }

    .expertise-tags {
      padding: 1rem;
      gap: clamp(0.3rem, 1vw, 0.5rem);

      .tag {
        padding: clamp(0.3rem, 1vw, 0.5rem) clamp(0.8rem, 1.5vw, 1rem);
        font-size: clamp(0.7rem, 1.2vw, 0.8rem);
      }
    }
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 1rem;
  }
`;

const EnhancedTimeline = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 4rem auto;
  padding: 2rem 0;

  &::after {
    content: '';
    position: absolute;
    width: 6px;
    background: linear-gradient(180deg, #2d7ba8 0%, #34495e 100%);
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -3px;
    border-radius: 6px;
    box-shadow: 0 0 10px rgba(45, 123, 168, 0.2);
  }

  .timeline-item {
    padding: 2rem;
    position: relative;
    width: 50%;

    &.left {
      left: 0;
      padding-right: 4rem;
    }

    &.right {
      left: 50%;
      padding-left: 4rem;
    }

    .timeline-marker {
      position: absolute;
      width: 40px;
      height: 40px;
      background: #2d7ba8;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 20px rgba(45, 123, 168, 0.3);
      z-index: 2;

      &::before {
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        background: white;
        border-radius: 50%;
      }
    }

    .content-wrapper {
      background: white;
      padding: 2rem;
      border-radius: 15px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      position: relative;
      transition: all 0.3s ease;

      .icon-wrapper {
        position: absolute;
        top: -20px;
        left: 20px;
        width: 40px;
        height: 40px;
        background: #2d7ba8;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
      }

      h3 {
        margin: 1rem 0;
        color: #2d7ba8;
      }

      p {
        color: #64748b;
        line-height: 1.6;
      }

      .milestone-badge {
        position: absolute;
        bottom: -10px;
        right: 20px;
        padding: 0.5rem 1rem;
        background: #34495e;
        color: white;
        border-radius: 20px;
        font-size: 0.8rem;
      }
    }
  }
    @media (max-width: 768px) {
    &::after {
      left: 2rem;
    }

    .timeline-item {
      width: 100%;
      padding: 1rem 1rem 1rem 3rem;

      &.left, &.right {
        left: 0;
        padding-left: 3rem;
      }

      .timeline-marker {
        left: 2rem;
        width: 30px;
        height: 30px;

        &::before {
          width: 15px;
          height: 15px;
        }
      }

      .content-wrapper {
        padding: 1.5rem;

        .icon-wrapper {
          width: 35px;
          height: 35px;
        }

        h3 {
          font-size: 1.2rem;
        }
      }
    }
  }

  @media (max-width: 480px) {
    margin: 2rem auto;
    
    .timeline-item {
      padding: 1rem 0.5rem 1rem 2.5rem;
      
      .content-wrapper {
        padding: 1rem;
      }
    }
  }
`;
const CTAWrapper = styled.div`
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 30px;
  padding: 4rem 2rem;
  margin: 2rem auto;
  max-width: 1200px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%232d7ba8' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.1;
  }

  .cta-content {
    text-align: center;
    position: relative;
    z-index: 1;

    h2 {
      color: #1e293b;
      font-size: 2.5rem;
      margin-bottom: 1rem;
      font-weight: 700;
    }

    p {
      color: #64748b;
      font-size: 1.2rem;
      margin-bottom: 2.5rem;
    }
  }

  .contact-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-bottom: 3rem;

    .contact-item {
      display: flex;
      align-items: center;
      gap: 1rem;
      padding: 1.5rem;
      background: white;
      border-radius: 15px;
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 15px 30px rgba(45, 123, 168, 0.15);
      }

      .icon-wrapper {
        width: 50px;
        height: 50px;
        background: #f1f5f9;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.5rem;
      }

      .contact-info {
        text-align: left;

        h4 {
          color: #1e293b;
          margin-bottom: 0.3rem;
        }

        a {
          color: #2d7ba8;
          text-decoration: none;
          font-size: 1.1rem;
          transition: color 0.3s ease;

          &:hover {
            color: #34495e;
          }
        }
      }
    }
  }

  .social-bar {
    display: flex;
    justify-content: center;
    gap: 1.5rem;
    margin-bottom: 3rem;

    .social-icon {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: white;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #2d7ba8;
      font-size: 1.5rem;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;

      &:hover {
        background: #2d7ba8;
        color: white;
        transform: translateY(-5px);
        box-shadow: 0 12px 25px rgba(45, 123, 168, 0.2);
      }
    }
  }

  .cta-buttons {
    display: flex;
    justify-content: center;
    gap: 1.5rem;
    flex-wrap: wrap;

    button {
      padding: 1rem 2.5rem;
      border-radius: 50px;
      font-size: 1.1rem;
      font-weight: 600;
      border: none;
      cursor: pointer;
      transition: all 0.3s ease;

      &.primary-btn {
        background: #2d7ba8;
        color: white;
        
        &:hover {
          background: #34495e;
        }
      }

      &.secondary-btn {
        background: white;
        color: #2d7ba8;
        border: 2px solid #2d7ba8;

        &:hover {
          background: #f8fafc;
          color: #34495e;
          border-color: #34495e;
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 3rem 1.5rem;

    .cta-content h2 {
      font-size: 2rem;
    }

    .contact-grid {
      grid-template-columns: 1fr;
    }

    .social-bar {
      gap: 1rem;
    }

    .cta-buttons {
      flex-direction: column;
      gap: 1rem;

      button {
        width: 100%;
      }
    }
  }
     @media (max-width: 480px) {
    padding: 2rem 1rem;

    .cta-content {
      h2 {
        font-size: 1.75rem;
      }

      p {
        font-size: 1rem;
      }
    }

    .contact-grid .contact-item {
      padding: 1rem;

      .icon-wrapper {
        width: 40px;
        height: 40px;
        font-size: 1.2rem;
      }
    }

    .social-bar {
      .social-icon {
        width: 40px;
        height: 40px;
        font-size: 1.2rem;
      }
    }
  }
`;
const StatsSection = styled.div`
  padding: 4rem 0;
  background: white;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);

  .stat-card {
    text-align: center;
    padding: 2rem;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
    }

    h3 {
      font-size: 2.5rem;
      color: #2d7ba8;
      margin-bottom: 0.5rem;
    }

    p {
      color: #64748b;
      font-size: 1.1rem;
    }
  }
     @media (max-width: 768px) {
    padding: 2rem 0;

    .stat-card {
      padding: 1.5rem;

      h3 {
        font-size: 2rem;
      }

      p {
        font-size: 1rem;
      }
    }
  }

  @media (max-width: 480px) {
    .stat-card {
      padding: 1rem;
      
      h3 {
        font-size: 1.75rem;
      }
    }
  }
`;
const StyledAboutPage = styled.div`
  background: #f8f9fa;
`;
const TabSection = styled.div`
  margin: 4rem 0;
  
  .tab-nav {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
    gap: 1rem;

    .nav-link {
      padding: 1rem 2rem;
      border-radius: 50px;
      background: transparent;
      color: #2d7ba8;
      border: 2px solid #2d7ba8;
      transition: all 0.3s ease;

      &.active {
        background: #2d7ba8;
        color: white;
      }

      &:hover:not(.active) {
        background: rgba(45, 123, 168, 0.1);
      }
    }
  }

  .tab-content {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    background: white;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);

    h3 {
      color: #2d7ba8;
      margin-bottom: 1rem;
    }

    p {
      color: #64748b;
      line-height: 1.8;
    }
  }
     @media (max-width: 768px) {
    margin: 2rem 0;

    .tab-nav {
      flex-wrap: wrap;
      gap: 0.5rem;

      .nav-link {
        padding: 0.75rem 1.5rem;
        font-size: 0.9rem;
      }
    }

    .tab-content {
      padding: 1.5rem;
      margin: 0 1rem;
    }
  }

  @media (max-width: 480px) {
    .tab-nav .nav-link {
      padding: 0.5rem 1rem;
      width: calc(50% - 0.5rem);
      text-align: center;
    }

    .tab-content {
      padding: 1rem;
    }
  }
`;

const Section = styled.section`
  padding: 80px 0;
  @media (max-width: 768px) {
    padding: 40px 0;
  }

  @media (max-width: 480px) {
    padding: 30px 0;
  }
`;



export default AboutPage;